// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ve7LI","fullView":"styles_fullView__1TUGB"};